import type { StudioSeriesStatus } from '@/types/studio-series';

export type SeriesDisplayStatus = 'draft' | 'published';

/**
 * Series skip admin review, so only draft/published are meaningful. Rows
 * that went through the legacy review flow can still carry
 * `pending_review` / `rejected` — both render as draft (FRONT-376).
 */
export function toSeriesStatus(status: StudioSeriesStatus): SeriesDisplayStatus {
  return status === 'published' ? 'published' : 'draft';
}
